import { MrrTrendPanel } from "@/components/platform/MrrTrendPanel";
import { SEO } from "@/components/SEO";

const PlatformBilling = () => (
  <div className="space-y-6">
    <SEO title="MRR & Billing" description="Revenue trends and billing overview" />
    <div>
      <h1 className="text-2xl font-bold">MRR & Billing</h1>
      <p className="text-sm text-muted-foreground">Revenue trends and subscription billing overview</p>
    </div>
    <MrrTrendPanel />
  </div>
);

export default PlatformBilling;
